import store from "@/state/store";
import { NavigationGuardNext, Route, RouteConfig } from "vue-router";

const routes: RouteConfig[] = [
  {
    path: "/content/scripts",
    name: "scripts",
    props: true,
    meta: { authRequired: true },
    component: () =>
      import("@/router/views/personalizedContent/scripts-page.vue"),
    beforeEnter: (
      _to: Route,
      _from: Route,
      next: NavigationGuardNext
    ): void => {
      if (!store.getters["auth/hasFeature"]("realtalk")) {
        return next("/realtalk");
      }
      next();
    },
  },
  {
    path: "/content/:contentType(scripts)/:slug",
    name: "Script Preview",
    props: true,
    meta: { authRequired: true, featureRequired: "realtalk" },
    component: () =>
      import("@/router/views/personalizedContent/script-detail.vue"),
  },
  {
    path: "/scriptbuilder/:script?",
    name: "ScriptBuilder",
    props: true,
    meta: { authRequired: true, featureRequired: "realtalk" },
    component: () =>
      import("@/router/views/personalizedContent/script-builder.vue"),
  },
];

export default routes;
